import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const Item = (props) => {
  return(
    <tr>
      {props.isIngredient && (
        <td className="hidden-xxs-down">
          {!props.item.item.is_inventory_control?
            <span className="badge badge-pill badge-warning">MANUAL</span> :
            <span className="badge badge-pill badge-success">SCAN</span>
          }
        </td>
      )}
      <td>
        <NavLink to={`/inventory/${props.item.id}/`}>
          {props.item.id}
        </NavLink>
      </td>
      <td>
        {props.item.item.name}
      </td>
      {!props.isLeftover && (
        <td className="hidden-xs-down">
          {props.item.number_items}
        </td>
      )}
      <td className="d-flex">
        <span>{props.item.weight}</span>
        <span className="measureUnit">
          <span className="ml-025 badge badge-pill badge-info">{props.item.item.measure_unit ? props.item.item.measure_unit : 'kg'}</span>
        </span>
      </td>
    </tr>
  )
}

export default class ListGeneralItems extends Component {

  render(){
    return(
      <div className="card">
        <div className="card-header card-header-inverse">
          <h5 className="mb-0">{this.props.isIngredient ? 'Ingredients' : (this.props.isLeftover ? 'Leftovers' : 'Products')}</h5>
        </div>
        <div className="card-block p-0 m-0">

        {this.props.items.length ?
          <table className="table table-striped table-hover mb-0">
            <thead>
              <tr>
                {this.props.isIngredient && (<th className="hidden-xxs-down">Type</th>)}
                <th className="hidden-xs-down">Inventory ID</th><th className="hidden-sm-up">ID</th>
                <th>Item</th>
                {!this.props.isLeftover && (<th className="hidden-xs-down">Pieces</th>)}
                <th className="hidden-xs-down">{this.props.isIngredient ? 'Qty Taken' : (this.props.isLeftover ? 'Qty Left' : 'Qty')}</th>
                <th className="hidden-sm-up">{this.props.isIngredient ? 'Taken' : (this.props.isLeftover ? 'Left' : 'Qty')}</th>
              </tr>
            </thead>
            <tbody>
              {this.props.items.map((item, index)=>{
                return(
                  <Item
                    item={item}
                    isIngredient={this.props.isIngredient}
                    isLeftover={this.props.isLeftover}
                    key={index}
                  />
                )
              })}
            </tbody>
          </table>
          :
            <div className="empty-table"><span>Session without {this.props.isIngredient ? 'Ingredients' : (this.props.isLeftover ? 'Leftovers' : 'Products')}</span></div>
        }
        </div>
      </div>
    )
  }

}
